import { StyleColorSchemeType } from '../../../styles/enums';
import { TooltipDisplayType, TooltipProperty } from '../enum';

const TooltipProps = {
  props: {
    [TooltipProperty.ColorScheme]: {
      default: StyleColorSchemeType.White,
      type: String,
    },
    [TooltipProperty.DisplayType]: {
      default: TooltipDisplayType.Static,
      type: String,
    },
    [TooltipProperty.Position]: {
      default: null,
      type: Object,
    },
  },
};

export default TooltipProps;
